import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div``;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const Select = styled.div`
  display: flex;
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  ${({ disabled, theme }) => disabled && `background-color: ${theme.colors.grey001}`};
`;

export const TextInput = styled.input`
  flex-grow: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  border: none;
  outline: none;
`;

export const Icon = styled.div`
  padding-left: 10px;
  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 12px;
  }
`;

export const Envelop = styled.div`
  position: absolute;
  top: 46px;
  width: 100%;
  height: 230px;
  padding: 4px 0;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 2;
  overflow: scroll;
`;

export const EnvelopItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const SelectedItemsWrapper = styled.div``;

export const SelectedItem = styled(typography.BodyTextOneRegularTypography)`
  display: inline-flex;
  margin: 8px 8px 0 0;
  padding: 2px 8px;
  color: ${({ theme }) => theme.colors.blueMain};
  background-color: ${({ theme }) => theme.colors.blueLight};
  border-radius: 6px;
`;

export const SelectedItemCloseIcon = styled.span`
  &:after {
    content: '\\e91f';
    font-family: icomoon;
    font-size: 10px;
    font-weight: 900;
    margin-inline-start: 10px !important;
    color: ${({ theme }) => theme.blueMain};
    cursor: pointer;
  }
`;
